import { navigateToBookingsCalendarPage } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { CreateActionParams } from '../actions';
import { BookingsGroup } from '../../types';

export type ClickOnReschedule = (args: { group: BookingsGroup }) => void;

export function createClickOnRescheduleAction({
  context,
}: CreateActionParams): ClickOnReschedule {
  return async ({ group }) => {
    const { flowAPI } = context;
    const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
    const slug = group.bookings[0].service?.mainSlug?.name;

    try {
      await navigateToBookingsCalendarPage(wixCodeApi, platformAPIs as any, {
        serviceSlugOrBasket: slug,
        navigationContext: {
          bookingId: group.bookings[0].bookingId,
        },
      });
    } catch {
      wixCodeApi.location.to?.('/');
    }
  };
}
